import { styled } from "@mui/material/styles";
import React from "react";

const StyledLozenge = styled("div")<{ size?: "normal" | "small" }>(
  ({ theme, size = "normal" }) => ({
    textTransform: "uppercase",
    display: "inline-block",
    textAlign: "center",
    ...(size === "normal" && {
      padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
      borderRadius: theme.spacing(0.5),
    }),
    ...(size === "small" && {
      padding: `${theme.spacing(0.2)} ${theme.spacing(0.4)}`,
      borderRadius: theme.spacing(0.3),
      fontWeight: 300,
      fontSize: theme.spacing(1),
    }),
  }),
);

type Props = React.HTMLAttributes<HTMLSpanElement> & {
  label: string;
  textColor: string;
  backgroundColor: string;
  size?: "normal" | "small";
};

const Lozenge = React.memo(function Lozenge({
  label,
  textColor,
  backgroundColor,
  size = "normal",
  className,
  style,
  ...rest
}: Props) {
  return (
    <StyledLozenge
      {...rest}
      size={size}
      className={className}
      style={{
        ...style,
        color: textColor,
        backgroundColor,
      }}
    >
      {label}
    </StyledLozenge>
  );
});

export default Lozenge;
